/**
 * LLM Connector models.
 *
 * Mirrors `CCMSLib.Models.Connector` (migration 245). These back two console surfaces:
 * the user's "Connected apps" page (their own grants) and the Connector admin page
 * (kill switches, every grant, the audit log, registered clients).
 *
 * Timestamps are the platform's yyyyMMddHHmmss decimals; 0 means "never".
 */
/** The scope catalogue, kept in step with `ConnectorScopes` on the backend for display. */
export const CONNECTOR_SCOPE_LABELS = {
    'ccms.tasks.read': 'See tasks',
    'ccms.tasks.write': 'Create and update tasks',
    'ccms.hr.read': 'See leave, duties and policies',
    'ccms.hr.write': 'Request and cancel leave',
    'ccms.directory.read': 'Look up colleagues and own profile',
    'ccms.directory.write': 'Update own member profile',
    'ccms.bookings.read': 'See bookings and availability',
    'ccms.commerce.read': 'See orders, requests and budgets',
    'ccms.commerce.write': 'Place orders and raise requests',
    'ccms.knowledge.read': 'Search knowledge base and courses',
    'ccms.apps.read': 'See CCMS apps',
    'ccms.notifications.read': 'See notifications and messages',
    'ccms.notifications.write': 'Mark read and send messages',
    'ccms.dashboard.read': 'See dashboard overview',
};
//# sourceMappingURL=Connector.js.map